<template>
  <div v-if="opportunite">
    <b-modal v-model="isComponentEnregistrerOpportuniteActive"
             has-modal-card
             class="modal"
             @close="closeOpportunite()">
      <app-enregistrer-opportunite/>
    </b-modal>
    <b-modal v-model="isComponentOuvrirEnvoiMail"
             has-modal-card class="modal" @close="closeMail()">
      <app-envoi-mail @close="closeMail()"
        :opportunite-id="opportunite.id"
        :opportunite-contact="opportunite.data.contact"
        :afficher-recap="opportunite.afficherRecap"
        :permalink="opportunite.permalink"/>
    </b-modal>
    <b-modal v-model="isComponentConfirmationMail"
             has-modal-card class="modal">
      <app-confirmation-mail :url="opportunite.url"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import * as typesClient from '@/store/modules/client-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import enregistrerOpportunite from './enregistrerOpportunite';
import envoiMail from './envoiMail';
import confirmationMail from './confirmationMail';

const Panier = createNamespacedHelpers('panier');
const Client = createNamespacedHelpers('client');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'index',
  data() {
    return {
      test: 1,
    };
  },
  props: ['url'],
  components: {
    appEnregistrerOpportunite: enregistrerOpportunite,
    appEnvoiMail: envoiMail,
    appConfirmationMail: confirmationMail,
  },
  computed: {
    ...Panier.mapGetters({
      panier: 'panier',
      opportunite: 'opportunite',
      getContactPanier: 'contactPanier',
      getClientPanier: 'clientPanier',
    }),
    ...Modal.mapGetters({
      getIsComponentOuvrirEnvoiMail: 'isComponentOuvrirEnvoiMail',
      getIsComponentEnregistrerOpportuniteActive: 'isComponentEnregistrerOpportuniteActive',
      getIsComponentConfirmationMail: 'isComponentConfirmationMail',
    }),
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
    clientPanier: {
      get() {
        return this.getClientPanier;
      },
      set(value) {
        this.setClientPanier(value);
      },
    },
    client: {
      get() {
        return this.getClient;
      },
      set(value) {
        this.setClient(value);
      },
    },
    isComponentOuvrirEnvoiMail: {
      get() {
        return this.getIsComponentOuvrirEnvoiMail;
      },
      set(value) {
        this.setIsComponentOuvrirMail(value);
      },
    },
    isComponentEnregistrerOpportuniteActive: {
      get() {
        return this.getIsComponentEnregistrerOpportuniteActive;
      },
      set(value) {
        this.setIsComponentEnregistrerOpportuniteActive(value);
      },
    },
    isComponentConfirmationMail: {
      get() {
        return this.getIsComponentConfirmationMail;
      },
      set(value) {
        this.setIsComponentConfirmationMail(value);
      },
    },
  },
  methods: {
    ...Panier.mapMutations({
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
      setClientPanier: typesPanier.SET_CLIENT_PANIER,
      setResetPanier: typesPanier.RESET_PANIER,
    }),
    ...Client.mapMutations({
      setClient: typesClient.SET_CLIENT,
    }),
    ...Modal.mapMutations({
      setIsComponentOuvrirMail: typesModal.SET_IS_COMPONENT_OUVRIR_MAIL,
      setIsComponentEnregistrerOpportuniteActive:
      typesModal.SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE,
      setIsComponentConfirmationMail: typesModal.SET_IS_COMPONENT_CONFIRMATION_MAIL,
    }),
    closeOpportunite() {
      if (!this.isComponentOuvrirEnvoiMail) {
        this.resetPanier();
      }
    },
    closeMail() {
      this.resetPanier();
    },
    resetPanier() {
      this.clientPanier = null;
      this.contactPanier = null;
      this.client = null;
      this.setResetPanier();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/envoyerOpportunite/index.vue